import { render, staticRenderFns } from "./FlickityCarousel.vue?vue&type=template&id=3ef25988&scoped=true&"
import script from "./FlickityCarousel.vue?vue&type=script&lang=js&"
export * from "./FlickityCarousel.vue?vue&type=script&lang=js&"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&lang=css&"
import style1 from "./FlickityCarousel.vue?vue&type=style&index=1&id=3ef25988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef25988",
  null
  
)

export default component.exports